export class OrderFilter {
    
    constructor(dateFrom?: Date, dateTo?: Date, customerId?: string) {
        
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.customerId = customerId;
    }

    dateFrom?: Date
    dateTo?: Date;
    customerId?: string;
}